import type { Issue } from '../types/issue';
import type { IssueNextAction } from './issueNextAction';

export type WorkspaceTab = 'work' | 'context' | 'history';

export type WorkspaceWorkFocus =
  | 'investigation'
  | 'cause'
  | 'treatment'
  | 'efficacy'
  | 'closed'
  | 'legacy';

type FocusIssue = Pick<Issue, 'mode' | 'status'>;
type FocusAction = Pick<IssueNextAction, 'key' | 'kind' | 'legacy'>;

/**
 * O que a área de trabalho abre.
 * A próxima ação continua vindo de deriveProblemNextAction. Aqui só se escolhe a superfície.
 */
export function workspaceWorkFocus(issue: FocusIssue, next: FocusAction): WorkspaceWorkFocus {
  if (issue.status === 'closed' || next.kind === 'close' || next.key === 'closed') return 'closed';
  if (next.legacy) return 'legacy';
  if (
    next.key === 'verify_efficacy'
    || next.key === 'revise_treatment'
    || next.key === 'close_problem'
    || next.key === 'closure_reason'
    || next.kind === 'validate'
    || issue.status === 'validation'
    || (issue.mode === 'structured_problem' && issue.status === 'monitoring')
  ) {
    return 'efficacy';
  }
  if (issue.mode === 'structured_problem' && (next.kind === 'root_cause' || issue.status === 'investigation' || issue.status === 'root_cause')) {
    if (issue.status === 'root_cause' || next.key === 'confirm_cause' || next.key === 'register_cause') return 'cause';
    return 'investigation';
  }
  return 'treatment';
}

export function workspaceShowsStructuredAnalysis(issue: Pick<Issue, 'mode'>): boolean {
  return issue.mode === 'structured_problem';
}

/** O aviso só aparece quando uma contramedida concluída ainda não encerra o problema. */
export function workspaceShowsResolutionCaveat(
  actions: Array<{ status: string }>,
  focus: WorkspaceWorkFocus,
): boolean {
  const completed = actions.some((action) => action.status === 'completed');
  return completed && (focus === 'efficacy' || focus === 'closed');
}

export function workspaceOpportunityPlacement(): 'secondary' {
  return 'secondary';
}

/** Sem contramedida concluída e sem tentativa, a eficácia não tem painel para preencher. */
export function efficacySurface(input: { completedCount: number; attemptCount: number }): 'empty' | 'full' {
  if (input.completedCount === 0 && input.attemptCount === 0) return 'empty';
  return 'full';
}
